import { PROJECT_STATUS } from "@/enums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Button, Col, Row } from "antd";
import styled from "styled-components";

// Project Header
export const ProjectHeaderRow = styled(Row)`
  background: #515355;
  padding: 0;
  border-left: 5px solid #db011c;
  border-radius: 8px;
`;

export const ActionCol = styled(Col)<{ $mobile?: boolean }>`
  ${({ $mobile }): string =>
    $mobile === true ? "padding: 16px 0px 16px 0px;" : ""};
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-left: none;
  background: #fff;
`;

export const ImageCol = styled(Col)`
  margin-top: auto;
  margin-bottom: auto;
  padding: 10px;
`;

export const TitleCol = styled(Col)<{ $mobile?: boolean }>`
  ${({ $mobile }): string =>
    $mobile === true
      ? "padding: 8px 0px 10px 10px;"
      : "padding: 16px 10px 10px 10px;"};
  flex: 1 1 0;
`;

// Project Image
export const ImageWrapper = styled.div`
  height: 90px;
  width: 90px;
  padding: 0;
`;

// Project Title
export const ProjectTitleText = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  line-height: normal;
  word-break: break-word;
`;

export const ProjectTitleWrapper = styled.div`
  padding-bottom: 8px;
`;

// Project Title Info
export const ProjectInfoWrapper = styled(Row)`
  padding-top: 6px;
`;

export const ProjectInfoLabel = styled.div`
  font-size: 14px;
  color: #fff;
`;

export const ProjectInfoValue = styled.div`
  font-size: 16px;
  color: #fff;
  line-height: 16px;
`;

// Project Status Badge
export const StyledStatusBadge = styled(Badge)<{ $editable?: boolean }>`
  .ant-badge-status-default,
  .ant-badge-status-warning,
  .ant-badge-status-success,
  .ant-badge-status-error {
    height: 28px !important;
    width: 28px !important;
    border: 2px solid #000;
  }

  .ant-badge-status-text {
    margin: 0;
  }

  ${({ $editable }): string => ($editable === true ? "cursor: pointer;" : "")};
`;

export const ProjectStatusBadgeWrapper = styled(Col)`
  margin: auto;
  width: 80px;
`;

export const StatusBadgeRow = styled(Row)`
  padding: 0 10px 0 24px;
  height: 100%;
`;

export const StatusBadgeLabel = styled.span`
  font-weight: bold;
`;

// Project Team Button
export const ProjectHeaderButton = styled(Button)`
  border: none;
  height: 100%;
  width: 100%;
  font-weight: bold;
  font-size: 12px;
  border-radius: 0;
  white-space: pre-wrap;
  line-height: normal;
  min-width: 150px;

  &:hover {
    background-color: #e9e9e9;
    color: #000;
  }

  &:active {
    background-color: #abacad;
    color: #000;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  height: ${({ height }): string | number | undefined => height || "42px"};
  width: ${({ height }): string | number | undefined => height || "42px"};
`;

export const RotateIcon = styled(FontAwesomeIcon)<{ $expand?: boolean }>`
  transition: transform 0.5s;
  transform: ${({ $expand }): string => ($expand ? "" : "rotate(180deg)")};
`;

const statusTheme = {
  active: {
    main: "#008745",
    hover: "#006735",
    click: "#343434",
  },
  onHold: {
    main: "#FF9E3D",
    hover: "#F57C00",
    click: "#343434",
  },
  complete: {
    main: "#076Ae6",
    hover: "#0041B3",
    click: "#343434",
  },
  canceled: {
    main: "#AD0015",
    hover: "#830010",
    click: "#343434",
  },
};

const handleButtonColor = (status: string, type: string): string => {
  switch (status) {
    case PROJECT_STATUS.project.active.id:
      return statusTheme.active[type as keyof typeof statusTheme.active];
    case PROJECT_STATUS.project.complete.id:
      return statusTheme.complete[type as keyof typeof statusTheme.complete];
    case PROJECT_STATUS.project.canceled.id:
    case PROJECT_STATUS.intake.canceled.id:
      return statusTheme.canceled[type as keyof typeof statusTheme.canceled];
    case PROJECT_STATUS.project.onHold.id:
    default:
      return statusTheme.onHold[type as keyof typeof statusTheme.onHold];
  }
};

export const StyledStatusButton = styled(Button)<{ $status?: string }>`
  height: 100%;
  width: 100%;
  min-width: 150px;
  border: none;
  border-radius: 0;
  background: ${({ $status }): string => handleButtonColor($status, "main")};
  color: #fff;
  font-weight: bold;

  &:hover {
    background: ${({ $status }): string => handleButtonColor($status, "hover")};
    color: #fff;
  }

  &.ant-btn-text:not(:disabled):hover {
    background: ${({ $status }): string => handleButtonColor($status, "hover")};
    color: #fff;
  }

  &.ant-btn-text:disabled {
    background: ${({ $status }): string => handleButtonColor($status, "main")};
    color: #fff;
    cursor: default;
  }
`;

export const StatusRow = styled(Row)`
  line-height: normal;
  padding: 2px;
  white-space: pre-wrap;
`;

export const TeamsImage = styled.img`
  height: 30px;
  width: 30px;
`;
